const OperacionInicio = () => <div style={{ padding: '2rem' }}>Inicia Servicio - KIOSKO</div>;
export default OperacionInicio;
